var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWashHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.565,
    height: 56.501,
    viewBox: "0 0 65.565 56.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 22px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WashHand",
    transform: "translate(0 -35.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-1",
    d: "M-3469.717-3778.8a5.675,5.675,0,0,1-5.557-5.774,5.959,5.959,0,0,1,.037-.667,1.672,1.672,0,0,1,.068-.932l3.887-10.438a1.671,1.671,0,0,1,1.566-1.088h.009a1.672,1.672,0,0,1,1.564,1.1l3.427,9.5a5.993,5.993,0,0,1,.559,2.522A5.675,5.675,0,0,1-3469.717-3778.8Zm-2.095-6.811a1.694,1.694,0,0,1-.046.414,2.666,2.666,0,0,0-.074.624,2.335,2.335,0,0,0,2.215,2.431,2.333,2.333,0,0,0,2.215-2.431,2.58,2.58,0,0,0-.26-1.144,1.546,1.546,0,0,1-.07-.167l-1.909-5.288Z",
    transform: "translate(3515.054 3833.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-2",
    d: "M-3692-3594",
    transform: "translate(3698.851 3660.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-1",
    d: "M-3723.6-3541.784a1.669,1.669,0,0,1-1.181-.49l-11.818-11.818a1.67,1.67,0,0,1-.031-2.332l5.323-5.612a1.663,1.663,0,0,1,1.19-.521,1.663,1.663,0,0,1,1.2.49l11.818,11.817a1.672,1.672,0,0,1,.031,2.333l-5.323,5.612a1.676,1.676,0,0,1-1.191.522Zm-9.484-13.521,9.453,9.454,3.022-3.186-9.454-9.453Z",
    transform: "translate(3737.088 3634.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-1",
    d: "M-3667.779-3637.849a1.67,1.67,0,0,1-1.328-.655,1.672,1.672,0,0,1,.31-2.344c.031-.023,3.134-2.4,7.975-6.081a13.677,13.677,0,0,1,8.228-3.074h.02l13.6.774c3.912.223,6.235,1.3,7.1,3.31,1.118,2.594-.987,5.209-1.232,5.5a1.677,1.677,0,0,1-.906.552l-8.643,1.974a1.638,1.638,0,0,1-.372.043h-8.425a1.671,1.671,0,0,1-1.671-1.672,1.671,1.671,0,0,1,1.671-1.672h8.236l7.841-1.792c.311-.508.607-1.212.43-1.614-.218-.5-1.454-1.135-4.218-1.293l-13.576-.772a10.467,10.467,0,0,0-6.059,2.4c-4.835,3.674-7.933,6.05-7.964,6.073A1.665,1.665,0,0,1-3667.779-3637.849Z",
    transform: "translate(3679.728 3708.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-1",
    d: "M-3581.971-3626.057q-.579,0-1.193-.042c-6.481-.453-14.252-1.212-14.329-1.22a1.671,1.671,0,0,1-1.5-1.826,1.672,1.672,0,0,1,1.826-1.5c.077.008,7.8.762,14.236,1.212,5.424.377,7.979-2.534,8.15-2.736a1.455,1.455,0,0,1,.351-.327c.1-.073,10.487-7.284,14.1-10.133,3.083-2.43,2.792-3.146,2.154-4.717-.338-.831-2.1-.392-2.117-.387-.036.01-.063.016-.1.024l-12.737,2.735a1.671,1.671,0,0,1-1.986-1.282,1.672,1.672,0,0,1,1.283-1.985l12.687-2.724c1.624-.444,4.9-.507,6.065,2.361,1.217,2.994,1.07,5.252-3.183,8.6-3.483,2.744-12.689,9.158-14.1,10.137A12.945,12.945,0,0,1-3581.971-3626.057Z",
    transform: "translate(3619.982 3709.258)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashHand);
export default __webpack_public_path__ + "static/media/WashHand.6d261761.svg";
export { ForwardRef as ReactComponent };